<template>
  <FormElement :horizontal="false">
    <fieldset class="k-form-fieldset product-form-fieldset">
      <div v-if="kendoForm.visited &&
        kendoForm.errors &&
        kendoForm.errors.VALIDATION_SUMMARY" class="k-messagebox k-messagebox-error">
        {{ kendoForm.errors.VALIDATION_SUMMARY }}
      </div>

      <Field :name="'supplier_id'" :type="'text'" :component="'ProductForm'" :label="supplierMessage"
        :validator="requiredValidator">
        <template v-slot:ProductForm="{ props }">
          <DropDownList v-bind="props" @blur="props.onBlur" @focus="props.onFocus" :data-items="supplierItems"
            :text-field="'name'" :data-item-key="'id'" :value-field="'id'" :value-primitive="true" :filterable="true"
            @filterchange="filterChange" v-model="supplier_id" />
        </template>
      </Field>

      <Field :name="'category_id'" :type="'text'" :component="'ProductForm'">
        <input type="hidden" name="category_id" :value="selectedItem" />
      </Field>

      <Field :name="'category_name'" :type="'text'" :component="'ProductForm'" class="product-form-category-name">
        <template v-slot:ProductForm="{ props }">
          <FormInput v-bind="props" @input="onSearchCategory" :placeholder="placeholderCagegory" />
        </template>
      </Field>

      <TreeList class="product-form-tree_list" :style="{
        'max-height': '510px',
        overflow: 'auto',
      }" :navigatable="true" :expand-field="expandField" :sub-items-field="subItemsField"
        @expandchange="onExpandChange" :data-items="foundCategory" data-item-key="id" :columns="columnsCategory"
        :selected-field="selectedField" @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </TreeList>

      <Field :name="'name'" :type="'text'" :component="'ProductForm'" :label="productNameMessage"
        :validator="nameValidator">
        <template v-slot:ProductForm="{ props }">
          <FormInput v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus" />
        </template>
      </Field>

      <Field :name="'descr'" :type="'text'" :component="'ProductForm'" :label="productDescrMessage"
        :validator="requiredValidator">
        <template v-slot:ProductForm="{ props }">
          <FormTextArea v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus">
          </FormTextArea>
        </template>
      </Field>

      <Field :name="'base_price'" :type="'text'" :component="'ProductForm'" :label="priceMessage"
        :validator="nameValidator">
        <template v-slot:ProductForm="{ props }">
          <FormNumeric v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus">
          </FormNumeric>

          <Checkbox v-model="is_mode_from" label="Режим ОТ" @change="handlePriceType" />
        </template>
      </Field>

      <Button type="submit" :disabled="!kendoForm.allowSubmit" v-if="isShowSubmit">
        {{ submitMessage }}
      </Button>
    </fieldset>
  </FormElement>
</template>

<script>
import { Field, FormElement } from "@progress/kendo-vue-form";
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { TreeList, mapTree, extendDataItem } from '@progress/kendo-vue-treelist';
import FormInput from "../ProfileComponents/FormInput.vue";
import FormTextArea from "../ProfileComponents/FormTextArea.vue";
import FormNumeric from "../ProfileComponents/FormNumeric.vue";
import { Button } from "@progress/kendo-vue-buttons";
import { filterBy } from '@progress/kendo-data-query';
import { provideLocalizationService } from "@progress/kendo-vue-intl";
import axios from "axios";
import { Checkbox } from "@progress/kendo-vue-inputs";

import {
  requiredValidator,
  firstNameValidator
} from "../../assets/validators";
import { dataString } from "../../composables/dataString";

const suppliers = [];

export default {
  components: {
    Field,
    FormElement,
    FormInput,
    FormTextArea,
    FormNumeric,
    DropDownList,
    TreeList,
    Button,
    Checkbox
  },
  inject: {
    kendoForm: { default: {} },
    kendoLocalizationService: { default: null },
  },
  props: {
    updatePriceType: {
      type: Function,
      required: false,
      default: null
    },
    isShowSubmit: {
      type: Boolean,
      required: false,
      default: true
    },
    product: {
      type: Object,
      required: false,
    }
  },
  data: function () {
    return {
      firstChange: false,
      isInit: true,
      isShowFormInner: false,
      nameValidator: firstNameValidator,
      requiredValidator: requiredValidator,
      supplierItems: suppliers.slice(),
      supplier_id: {},
      categoryItems: [],
      category_id: 0,
      selectedField: 'selected',
      subItemsField: 'children',
      expandField: 'has_children',
      selectedItem: null,
      selectedItemName: '',
      expanded: [],
      selected: {},
      loader: false,
      searchName: null,
      searchVisible: 1,
      priceType: false,
      is_mode_from: this.product?.mode_from || false
    };
  },
  computed: {
    columnsCategory() {
      return [
        { field: "selected", width: "7%", headerSelectionValue: this.headerSelectionValue },
        { field: 'name', title: this.categoryNameText, expandable: true }
      ];
    },
    categoryNameText() {
      return provideLocalizationService(this).toLanguageString(
        "categoryNameText",
        "categoryNameText"
      );
    },
    dataState() {
      return {
        sort: this.sort,
        skip: this.skip,
        take: this.take,
      };
    },
    categoryData() {
      let data = this.categoryItems;
      return this.addExpandField(data);
    },
    submitMessage() {
      return provideLocalizationService(this).toLanguageString("btnSave", "btnSave");
    },
    supplierMessage() {
      return provideLocalizationService(this).toLanguageString("supplier", "Supplier");
    },
    placeholderCagegory() {
      return provideLocalizationService(this).toLanguageString("onSearchCategoryPlaceholder", "onSearchCategoryPlaceholder");
    },
    categoryMessage() {
      return provideLocalizationService(this).toLanguageString("category", "Category");
    },
    productNameMessage() {
      return provideLocalizationService(this).toLanguageString("productName", "Product Name");
    },
    productDescrMessage() {
      return provideLocalizationService(this).toLanguageString("productDescr", "Product Description");
    },
    priceMessage() {
      return provideLocalizationService(this).toLanguageString("price", "Price");
    },
    foundCategory() {
      function recursiveSearch(categories, name, results) {
        for (const category of categories) {
          const nameMatches = category.name.toLowerCase().includes(name.toLowerCase());

          if (nameMatches) {
            results.push(category);
          }

          if (category.has_children && category.children && category.children.length > 0) {
            recursiveSearch(category.children, name, results);
          }
        }
        return results;
      }

      let list = [];

      if (this.searchName === null || this.searchName === '') {
        list = this.categoryData;
      } else {
        list = recursiveSearch(this.categoryData, this.searchName, []);
      }

      if (this.isInit && this.product && this.product.id) {
        if (list && list[0]) {
          list = list.map((listItem) => {
            if (listItem.id === this.product.category_id) {
              listItem.selected = true;
            } else {
              listItem.selected = false;
            }

            this.isInit = false;
            return listItem;
          })
        }
      }

      return list;
    },
  },
  mounted() {
    var self = this;
    axios({
      url: '/api/v1/suppliers/select',
      params: {
        limit: 100
      }
    }).then(res => {
        if (res.data) {
          self.suppliers = res.data.data;
          self.supplierItems = res.data.data;
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.data.message) {
            alert(self.getMessageByLang('error', "Ошибка"))
          }
        } else if (error.request) {
          console.log(error.request);
          alert(self.getMessageByLang('error', "Ошибка"))
        }
      });
    axios.get('/api/v1/categories/tree?' + dataString(this.dataState))
      .then(res => {
        if (res.data) {
          if (res.data.message) {
            self.categoryItems = res.data.data;

            this.selectedItem = this.product.category_id;
          }
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.data.message) {
            alert(self.getMessageByLang('error', "Ошибка"))
          }
        } else if (error.request) {
          console.log(error.request);
        }
      })
      .finally(() => {
        setTimeout(() => {
          this.isShowFormInner = true;
        }, 1100);
      })
  },
  methods: {
    handlePriceType(event) {
      if(this.updatePriceType) {
        this.updatePriceType(event.value)
      }
    },

    onSearchCategory(event) {
      const text = event.target.value;
      this.searchName = text.toLowerCase();
    },

    listValidator() {
      if (this.selectedItem == null) {
        return 'Error: This field is required.';
      }
      return '';
    },
    filterChange(event) {
      this.supplierItems = this.filterData(event.filter);
    },
    filterData(filter) {
      const data = this.suppliers.slice();

      return filterBy(data, filter);
    },
    onExpandChange(e) {
      if (e.value) {
        this.expanded = this.expanded.filter((item) => {
          return item;
        })


      } else {
        let arr = [];

        if (!this.firstChange) {
          for (const category of this.foundCategory) {
            if (category.id === this.selectedItem) {
              category.selected = true;
            }
          }

          const newSelected = {};

          mapTree(this.categoryItems, this.subItemsField, (item) => {
            newSelected[item.id] = false;
            return item;
          });

          newSelected[this.selectedItem] = true;
          this.selected = newSelected;
          this.firstChange = true;
        }


        arr[e.dataItem.id] = true;
        this.expanded = JSON.parse(JSON.stringify(arr));
      }
    },
    addExpandField(dataTree) {
      const expanded = this.expanded;
      const selected = this.selected;

      return mapTree(dataTree, this.subItemsField, (item) =>
        extendDataItem(item, this.subItemsField, {
          [this.expandField]: expanded[item.id],
          [this.selectedField]: selected[item.id],
        })
      );
    },
    headerSelectionValue() {
      return false;
    },
    onSelectionChange(e) {
      const category_id = e.dataItem.id;
      const newSelected = {};

      // Очищаем все выбранные элементы
      mapTree(this.categoryItems, this.subItemsField, (item) => {
        newSelected[item.id] = undefined;
        return item;
      });

      // Выбираем только текущий элемент
      newSelected[category_id] = e.event.target.checked ? true : undefined;

      this.selectedItem = category_id;
      this.selectedItemName = e.event.target.checked ? e.dataItem.name : '';
      this.selected = newSelected;
    },
    onHeaderSelectionChange(event) {
      const checkboxElement = event.event.target;
      const checked = checkboxElement.checked;
      const newSelectedState = {};
      mapTree(this.categoryItems, this.subItemsField, (item) => {
        newSelectedState[item.id] = checked ? true : undefined;
        return item;
      });
      this.selected = newSelectedState;
    }
  }
};
</script>

<style lang="scss">
.product-form-category-name {
  & label {
    display: none !important;
  }
}

.product-form-tree_list {
  & thead .k-table-th {
    &:first-child>.k-cell-inner {
      display: none;
    }
  }
}
</style>